import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: 'index'
    },
    {
      path: '/index',
      component: () => import('@/views/index'),
      name: 'Index',
      meta: {title: 'Home'}
    },
    {
      path: '/about-us',
      component: () => import('@/views/about-us'),
      name: 'AboutUs',
      meta: {title: 'About Us'}
    },
    {
      path: '/products',
      component: () => import('@/views/products'),
      name: 'Products',
      meta: {title: 'Product Center'}
    },
    {
      path: '/products/detail',
      component: () => import('@/views/products/detail'),
      name: 'ProductDetail',
      meta: {title: 'Product Detail'}
    },
    {
      path: '/cases',
      component: () => import('@/views/cases'),
      name: 'Cases',
      meta: {title: 'Cooperation Cases'}
    },
    {
      path: '/contact-us',
      component: () => import('@/views/contact-us'),
      name: 'ContactUs',
      meta: {title: 'Contact Us'}
    },
    {
      path: '/phone',
      component: () => import('@/views/phone'),
      name: 'Phone',
      redirect: '/phone/index',
      meta: {title: ''},
      children: [
        {
          path: 'index',
          component: () => import('@/views/phone/home'),
          name: 'PhoneIndex',
          meta: {title: 'Home', noShowTitle: true}
        },
        {
          path: 'about-us',
          component: () => import('@/views/phone/about-us'),
          name: 'PhoneAboutUs',
          meta: {title: 'About Us', noShowTitle: true}
        },
        {
          path: 'products',
          component: () => import('@/views/phone/products'),
          name: 'PhoneProducts',
          meta: {title: 'Products', noShowTitle: true}
        },
        {
          path: 'products/detail',
          component: () => import('@/views/phone/products/detail'),
          name: 'PhoneProductDetail',
          meta: {title: 'Product Detail', noShowTitle: true}
        },
        {
          path: 'cases',
          component: () => import('@/views/phone/cases'),
          name: 'PhoneCooperationCases',
          meta: {title: 'Cooperation Cases', noShowTitle: true}
        },
        {
          path: 'contact-us',
          component: () => import('@/views/phone/contact-us'),
          name: 'PhoneContactUs',
          meta: {title: 'Contact Us', noShowTitle: true}
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js